import {ErrorHandler, Injectable} from "@angular/core";
import {AngularFireAuth} from "@angular/fire/compat/auth";
import * as Sentry from "@sentry/browser";
import firebase from "firebase/compat/app";

interface SentryServiceConfig {
  dsn: string;
  project: string;
  version: string;
  showReportDialog: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class SentryService {
  config: SentryServiceConfig;

  constructor(public firebaseAuth: AngularFireAuth) {
    firebaseAuth.user.subscribe(user => {
      Sentry.setUser(user ? {id: user.uid} : null);
    });
  }

  init(config: SentryServiceConfig) {
    this.config = config;
    if (!config)
      return;
    Sentry.init({
      dsn: config.dsn,
      release: `${config.project}@${config.version}`
    });
  }

  logSignIn(message: string, user: firebase.auth.UserCredential) {
    Sentry.addBreadcrumb({
      category: 'user',
      message,
      level: Sentry.Severity.Info,
      data: {uid: user ? user.user.uid : null}
    });
  }

  async logSignOut() {
    Sentry.addBreadcrumb({
      category: 'user',
      message: 'signOut',
      level: Sentry.Severity.Info,
      data: {uid: (await this.firebaseAuth.currentUser)?.uid || null}
    });
  }
}

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor(private sentryService: SentryService) {}

  handleError(error) {
    console.error(error);
    if (!this.sentryService.config)
      return;
    const eventId = Sentry.captureException(error.originalError || error);
    if(this.sentryService.config.showReportDialog)
      Sentry.showReportDialog({ eventId });
  }
}
